import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './slices/theme/themeSlice';
import userReducer from './slices/user/userSlice';
import courseReducer from './slices/course/courseSlice';

import watchHistoryReducer from '@/store/slices/dashboard/watchHistorySlice';
import favVideosReducer from '@/store/slices/dashboard/favVideosSlice';
import dashboardDetailsReducer from '@/store/slices/dashboard/dashboardDetailsSlice';
import examReducer from '@/store/slices/dashboard/examSlice';
import testReducer from '@/store/slices/dashboard/testSlice';
import screenWidthReducer from '@/store/slices/common/screenWidthSlice';
import currentThemeReducer from '@/store/slices/common/currentThemeSlice';
import timelineReducer from '@/store/slices/timeline/timelineSlice';
import seriesReducer from '@/store/slices/video/seriesSlice';
import videoReducer from '@/store/slices/video/videoSlice';
import timelineAccordionStatusReducer from '@/store/slices/timeline/timelineAccordionStatusSlice';
import certificateUIReducer from '@/store/slices/timeline/certificateUISlice';
import profileReducer from '@/store/slices/profile/profileSlice';
import profileStepNoReducer from '@/store/slices/profile/profileStepNo';
import ugDegreeListReducer from '@/store/slices/profile/ugDegreeListSlice';
import commentsReducer from '@/store/slices/comments/commentsSlice';
import tokenReducer from '@/store/slices/userAuth/token';
import navbarCoursesReducer from '@/store/slices/common/navbarCoursesSlice';
import examQuestionBankReducer from '@/store/slices/exam/examQuestionBankSlice';
import watchAccordionReducer from '@/store/slices/dashboard/watchAccordionSlice';


export const store = configureStore({
  reducer: {
    theme: themeReducer,
    user: userReducer,
    course: courseReducer,
    watchHistoryReducer: watchHistoryReducer,
    favVideosReducer: favVideosReducer,
    dashboardDetailsReducer: dashboardDetailsReducer,
    examReducer: examReducer,
    testReducer: testReducer,
    screenWidthReducer: screenWidthReducer,
    timelineAccordionStatusReducer: timelineAccordionStatusReducer,
    timelineReducer: timelineReducer,
    certificateUIReducer: certificateUIReducer,
    profileReducer: profileReducer,
    profileStepNoReducer: profileStepNoReducer,
    ugDegreeListReducer: ugDegreeListReducer,
    seriesReducer: seriesReducer,
    videoReducer: videoReducer,
    commentsReducer: commentsReducer,
    tokenReducer: tokenReducer,
    navbarCoursesReducer: navbarCoursesReducer,
    examQuestionBankReducer: examQuestionBankReducer,
    currentThemeReducer:currentThemeReducer,
    watchAccordionReducer: watchAccordionReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;